import { customizationParser } from "./services/helpers/customization-helper";

// Base assets with branding-specific paths
const defaultAssets = {
  policeLine:"img/default/rr_police_line.png",
  startLineImage:"img/default/rr_bank_start.png",
  coinImage:"img/default/rr_coin_glow.png",
  jackpotCoin:"img/default/rr_jackpot_coin.png",
  musicLoop:"sounds/default/background_music.mp3",
  fire:"img/default/rr_fire.png",
};

// You may need to dynamically load branding assets here or at initialization
const brandingAssets = {
  winner: {
    policeLine:"img/winner/rr_police_line.png",
    startLineImage:"img/winner/rr_bank_start.png",
    coinImage:"img/winner/rr_coin_glow.png",
    musicLoop:"sounds/winner/rr-background-music-theme.mp3",
  },
  maxbet: {
    policeLine:"img/maxbet/rr_police_line.png",
    startLineImage:"img/maxbet/rr_bank_start.png",
    coinImage:"img/maxbet/rr_coin_glow.png",
    musicLoop:"sounds/winner/rr-background-music-theme.mp3",
  },
  admiral: {
    policeLine:"img/admiral/rr_police_line.png",
    startLineImage:"img/admiral/rr_bank_start.png",
    coinImage:"img/admiral/rr_coin_glow.png",
    musicLoop:"sounds/winner/rr-background-music-theme.mp3",
  },
  // Add other branding-specific assets here
};

// Function to get branding assets based on the current branding
const getCurrentAssets = (branding = "default") => {
  return {
    ...defaultAssets,
    ...(brandingAssets[branding] || {}),
  };
};

const customization = customizationParser();

// Set the current branding somewhere in your app initialization
const currentBranding = customization?.branding || ""; // replace with actual branding logic

// Export assets based on the current branding
export const assets = getCurrentAssets(currentBranding);
